<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_officer') : $t('labels.add_qualification_officer') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-3 mb-4">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="officer_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.officer_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('officer_name') }}</span>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pl-3 mb-4">
              <label class="bold-fields">{{ $t('labels.officer_sequence')}}</label>
              <v-select
                class="w-full mt-1"
                v-model="display_number"
                :options="display_numbers"
                name="display_numbers"
                :reduce="display_numbers => display_numbers.value"
                label="name"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('officer_sequence') }}</span>
            </div>

            <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-3 mb-4">
              <label>{{ $t('labels.type')}}</label>
              <v-select
                class="w-full mt-1"
                v-model="type"
                :options="types"
                name="types"
                :reduce="types => types.value"
                label="name"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('country') }}</span>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pl-3 mb-4">
              <label class="bold-fields">{{ $t('labels.service')}}</label>
              <v-select
                v-model="service"
                class="w-full mt-1"
                :options="services_drop"
                :reduce="services_drop => services_drop.id"
                label="name"
                name="services"
                v-validate="'required'"
                :closeOnSelect="true"
              />
              <span class="text-danger text-sm">{{ errors.first('services') }}</span>
            </div>
          </div>
          <div class="vx-col sm: w-full sm: p-0 mb-4">
            <label class="bold-fields">{{ $t('labels.description')}}</label>
            <vs-textarea
              type="text"
              class="w-full mb-0 mt-1"
              name="description"
              :placeholder="$t('labels.description')"
              maxlength="5000"
              v-model="description"
              icon-no-border
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{ errors.first('description') }}</span>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-officer"
              button="submit"
            >{{ editRoute ? $t('labels.update_officer') : $t('labels.add_qualification_officer') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      name: "",
      description: "",
      display_number: "",
      service: [],
      services_drop: [],
      type: "",
      types: [
        { name: "Qualification Officer", value: "QO" },
        { name: "Qualification Engineer", value: "QE" }
      ],
      display_numbers: [
        { name: "1", value: 1 },
        { name: "2", value: 2 },
        { name: "3", value: 3 },
        { name: "4", value: 4 },
        { name: "5", value: 5 },
        { name: "6", value: 6 },
        { name: "7", value: 7 },
        { name: "8", value: 8 },
        { name: "9", value: 9 },
        { name: "10", value: 10 },
        { name: "11", value: 11 },
        { name: "12", value: 12 },
        { name: "13", value: 13 },
        { name: "14", value: 14 },
        { name: "15", value: 15 },
        { name: "16", value: 16 },
        { name: "17", value: 17 },
        { name: "18", value: 18 },
        { name: "19", value: 19 },
        { name: "20", value: 20 }
      ]
    };
  },
  components: {
    "v-select": vSelect
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getServices();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getOfficers();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateOfficer();
        }
      });
    },
    // API Integration for add-update top-events
    async createUpdateOfficer() {
      let input = {
        name: this.name,
        description: this.description,
        display_number: this.display_number,
        type: this.type,
        service_id: this.service
      };
      if (this.type) {
        if (this.type === "Qualification Officer") {
          input = Object.assign(input, {
            type: "QO"
          });
        }
        if (this.type === "Qualification Engineer") {
          input = Object.assign(input, {
            type: "QE"
          });
        }
      }
      let url = this.editRoute
        ? "/qualifications/update/" + this.editRoute
        : "/qualifications/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-officer",
        true
      );
      if (response) {
        this.$router.push({ name: "Officers" });
      }
    },
    async getOfficers() {
      let response = await this.getHTTPGetResponse(
        "/qualifications/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let officers = data.qualification_role;
        this.name = officers.name;
        this.description = officers.description;
        this.display_number = officers.display_number;
        this.type = officers.type_name;
        this.service = officers.service_id;
      }
    },
    async getServices() {
      let input = {
        name: this.service
      };
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let service_req = response.data.services;
        let filteredServices = [];
        for (var i = 0; i < service_req.length; i++) {
          if (service_req[i].id === 1 || service_req[i].id === 2) {
            let obj = { id: service_req[i].id, name: service_req[i].name };
            filteredServices.push(obj);
          }
        }
        this.services_drop = filteredServices;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
